import { Option } from "effect";
import * as AsyncResult from "effect/unstable/reactivity/AsyncResult";
import { useActiveSite, useMySites } from "./sites.queries";
import { resolveToolGap, type ToolGapResult } from "./tool-gap";

/**
 * 当前活动站点相对某项 Capability 的第一层缺口。
 * sites 查询未完成时保持 loading，避免把 null 活动站点误判成「没站点」。
 */
export function useToolGap(capabilityReady: boolean): ToolGapResult {
  const result = useMySites();
  const activeSite = useActiveSite();
  const data = AsyncResult.value(result).pipe(Option.getOrUndefined);
  const sitesLoaded = data?.success === true || !AsyncResult.isWaiting(result);
  return resolveToolGap({
    sitesLoaded,
    activeSite,
    capabilityReady,
  });
}
